/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./group-legend.vue?vue&type=template&id=3e7b0a54&scoped=true&"
import script from "./group-legend.vue?vue&type=script&lang=js&"
export * from "./group-legend.vue?vue&type=script&lang=js&"
import style0 from "./group-legend.vue?vue&type=style&index=0&id=3e7b0a54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7b0a54",
  null
  
)

export default component.exports